import React from 'react';
import { useTranslation } from 'react-i18next';

import { unitsModel } from '../../../constants';
import { LabeledSelect } from '../Input/LabeledSelect';

const YesNoSelect = ({ withAll = true, allowClear = true, ...props }) => {
  const [ t ] = useTranslation();

  return (
    <LabeledSelect
      { ...props }
      allowClear={ allowClear }
      options={ [
        ...(withAll ? [ { value: unitsModel.ENTERED.ALL, text: t('fields.entered.all') } ] : []),
        { value: unitsModel.ENTERED.YES, text: t('fields.entered.yes') },
        { value: unitsModel.ENTERED.NO, text: t('fields.entered.no') }
      ] }
    />
  );
};
export default YesNoSelect;
